@let regularOpeningHours = configuration().openingHours.regularOpeningHours;

<div class="opening-table">
    @for (hours of regularOpeningHours; track hours) {
    <span [ngClass]="classes()">{{ hours.day }}:</span>
    <span [ngClass]="classes()">
        @if (hours.periods.length > 0) {
        <span class="time-frame">
            @for (period of hours.periods; track period;) {
            <div>{{ period.open }} - {{ period.close }} Uhr</div>
            }
        </span>
        }
        @else {
        <span class="time-frame"><div>Geschlossen</div></span>
        }
    </span>
    }
</div>